import { api } from "../api/client";

// Local mock submission for dev. Persists submitted orders/POs into
// sessionStorage so the success page can read them back.
function localSubmit(kind, payload) {
  const id = (kind === "po" ? "PO-" : "SO-") + Date.now().toString(36).toUpperCase();
  const record = {
    id,
    kind,                                      // "po" | "sales-order"
    status: kind === "po" ? "pending_approval" : "received",
    createdAt: new Date().toISOString(),
    items: payload?.items || [],
    shipping: payload?.shipping || null,
    customer: payload?.customer || null,
    totals: payload?.totals || {},
  };
  try {
    const raw = sessionStorage.getItem("mr.b2b.localOrders");
    const all = raw ? JSON.parse(raw) : [];
    all.push(record);
    sessionStorage.setItem("mr.b2b.localOrders", JSON.stringify(all));
  } catch { /* quota */ }
  return record;
}

async function withMock(promise, fallback) {
  try {
    const out = await promise;
    if (out && out.id) return out;
    return fallback();
  } catch {
    return fallback();
  }
}

export const OrderController = {
  list() { return api.listOrders(); },
  get(id) { return api.getOrder(id); },
  fromQuote(quoteId) { return api.convertQuoteToOrder(quoteId); },

  // Direct submission paths used by the new /checkout flow.
  submitSalesOrder(payload) {
    return withMock(
      api.submitSalesOrder ? api.submitSalesOrder(payload) : Promise.resolve(null),
      () => localSubmit("sales-order", payload),
    );
  },
  submitPurchaseOrder(payload) {
    return withMock(
      api.submitPurchaseOrder ? api.submitPurchaseOrder(payload) : Promise.resolve(null),
      () => localSubmit("po", payload),
    );
  },
};
